
import React, { PureComponent } from 'react';
import "./Forms.css";
import CONSTANTS from '../../constants.js';
import { connect } from 'react-redux';
import { setUploadFiles, setCustomerAttachmentId } from '../../actions/action';
import fetchApiData from '../apiHandlers/fetchApiData';
import Dropzone from 'react-dropzone'

const mapStateToProps = state => state;
const mapDispatchToProps = { setUploadFiles, setCustomerAttachmentId };

class Attachments extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      showFormErrors: false,
      ErrorMsg: "",
      isLoading: false
    };
  }

  validateAttachmentFile(file) {
    let fileList = this.props.store.UploadFiles
    let attachmentId = this.props.store.customerAttachmentId
    const fileService = new fetchApiData();

    const formData = new FormData();
    formData.append('file', file);
    fileService.postSendFile(formData).then(
      res => {
        switch (res.errorCode) {
          case 0:
            file.attachmentUrl = res.encodedUrl
            fileList.push(file)
            this.props.setUploadFiles(fileList);
            if (attachmentId === "") {
              this.props.setCustomerAttachmentId(res.customerAttachmentId);
            }
            this.setState({ isLoading: false })
            this.setState({ showFormErrors: false })
            break

          default:
            this.setState({ isLoading: false })
            this.setState({ showFormErrors: true });
            this.setState({ ErrorMsg: res.message });
            break
        }
      },
      error => {
        console.log(error)
        this.setState({ isLoading: false })
        this.setState({ showFormErrors: true });
        this.setState({ ErrorMsg: error.message });
      }
    )
  }
  removeFile = file => {
    let fileList = this.props.store.UploadFiles
    const removeFileService = new fetchApiData();
    //remove file from front only
    const newFiles = [...fileList];     // make a var for the new array
    newFiles.splice(newFiles.indexOf(file), 1);        // remove the file from the array
    this.props.setUploadFiles(newFiles);
    //OLD Code
    removeFileService.DeleteAttachment(file.attachmentUrl).then(
      res => {
        if (res.d.status === 'OK') {
          const newFiles = [...fileList];     // make a var for the new array
          newFiles.splice(newFiles.indexOf(file), 1);        // remove the file from the array
          this.props.setUploadFiles(newFiles);
        }
      },
      error => {
        this.setState({ isLoading: false })
        this.setState({ showFormErrors: true });
        this.setState({ ErrorMsg: error.message });
      }
    )
  }

  render() {
    const isLoading = (this.state.isLoading ? " isLoading" : "");
    return (
      <React.Fragment>
        <div className={`form-wrapper ${this.props.classes}`}>
          <Dropzone onDrop={acceptedFiles => {
            if (acceptedFiles.length > 3) {
              this.setState({ showFormErrors: true });
              this.setState({ ErrorMsg: "Un client ne peut uploadé que 3 pièces jointes max." });
            } else {
              acceptedFiles.forEach((file) => {
                this.setState({ showFormErrors: false });

                const reader = new FileReader()

                reader.onabort = () => { console.log('file reading was aborted') }
                reader.onerror = () => { console.log('file reading has failed') }
                reader.onload = () => {
                  console.log('file loading ...')
                  this.setState({ isLoading: true })
                  this.validateAttachmentFile(file)
                }
                reader.readAsArrayBuffer(file)
              })
            }
          }}>
            {({ getRootProps, getInputProps }) => (
              <div>
                <div {...getRootProps()} className={"services-attachments__block" + isLoading}>
                  <input {...getInputProps()} />
                  {<span>{CONSTANTS.LABELS.needs_attachment_cta1}</span>}
                  <div className="services-attachments__button">
                    <label className="label-file">{CONSTANTS.LABELS.needs_attachment_cta2}</label>
                  </div>
                </div>

                {
                  <React.Fragment>

                    {
                      this.props.store.UploadFiles.length > 0 &&
                      <div className="services-attachments__files">
                        {
                          Object.values(this.props.store.UploadFiles).map((file, key) => {
                            return <span key={key}>{file.path}
                              <i
                                tabIndex='0'
                                onKeyDown={(e) => e.key === 'Enter' && this.removeFile(file)}
                                onClick={() => this.removeFile(file)}
                                className='mark-icons delete-icon'
                              />
                            </span>
                          })
                        }
                      </div>
                    }
                  </React.Fragment>
                }
              </div>
            )}
          </Dropzone>
        </div>
        {this.state.showFormErrors && <div className="section-form"><span className="input-errorLabel">{this.state.ErrorMsg}</span></div>}
      </React.Fragment>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Attachments);